interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: React.ReactNode;
  trend?: 'up' | 'down' | 'neutral';
  trendValue?: string;
}

export function StatCard({
  title,
  value,
  subtitle,
  icon,
  trend,
  trendValue,
}: StatCardProps) {
  return (
    <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-xl p-5 hover:border-[#3a3a3a] transition-colors">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-[var(--text-muted)] text-sm font-medium">{title}</p>
          <p className="text-3xl font-semibold mt-1 tracking-tight">{value}</p>
          {subtitle && (
            <p className="text-[var(--text-secondary)] text-sm mt-1">{subtitle}</p>
          )}
        </div>
        {icon && (
          <div className="w-10 h-10 bg-[var(--bg-tertiary)] rounded-lg flex items-center justify-center text-[var(--text-secondary)]">
            {icon}
          </div>
        )}
      </div>
      {trend && trendValue && (
        <div className="mt-3 flex items-center gap-1">
          {trend === 'up' && (
            <span className="text-green-400 text-sm">↑ {trendValue}</span>
          )}
          {trend === 'down' && (
            <span className="text-red-400 text-sm">↓ {trendValue}</span>
          )}
          {trend === 'neutral' && (
            <span className="text-[var(--text-muted)] text-sm">→ {trendValue}</span>
          )}
        </div>
      )}
    </div>
  );
}

